var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-location-section',{staticClass:"user-location-section-module",attrs:{"label":_vm.attributes.label,"button-text":_vm.attributes.userLocation_button_text,"redirect":_vm.redirect}})}
var staticRenderFns = []

export { render, staticRenderFns }